import { loadLanguageAsync } from '@/i18n'

export default {
  created () {
    loadLanguageAsync()
  },
  methods: {
    sendEmail (email) {
      this.resetResponse()
      return this.$api.resetPassword(email)
        .then(() => {
          this.$store.commit('RESET_PWD_DONE', true)
          this.$router.push('/login')
        })
        .catch((error) => {
          this.response = error.data
          this.loading = false
        })
    },
    resetResponse () {
      this.response = ''
    },
    validateForm () {
      return this.$validator.validateAll().then((valid) => {
        if (valid) {
          const { email } = this
          this.loading = true
          return this.sendEmail(email)
        }
      })
    }
  },
  name: 'ResetPassword',
  data (router) {
    return {
      email: '',
      loading: false,
      response: '',
      section: 'Reset Password'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js